
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{attrs:{"id":"a","fill":"#fff"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.405 9.14a1 1 0 00-.16.542v3.972a1 1 0 01-.505.869l-2.49 1.419a1 1 0 01-1.495-.87V9.68a1 1 0 00-.16-.543L.704 1.574a1 1 0 01.84-1.543h12.913a1 1 0 01.84 1.543L10.405 9.14z"}})]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.405 9.14a1 1 0 00-.16.542v3.972a1 1 0 01-.505.869l-2.49 1.419a1 1 0 01-1.495-.87V9.68a1 1 0 00-.16-.543L.704 1.574a1 1 0 01.84-1.543h12.913a1 1 0 01.84 1.543L10.405 9.14z","fill":"#ABAFB5"}}),_c('path',{attrs:{"d":"M15.297 1.574l-.672-.434.672.434zM5.595 9.137l-.672.435.672-.435zm1.655 6.805l.396.695-.396-.695zm2.49-1.42l-.396-.694.396.695zm.665-5.383l.672.435-.672-.435zm-.96.543v3.972h1.6V9.682h-1.6zm-.101 4.146l-2.49 1.419.792 1.39 2.49-1.42-.792-1.39zm-2.789 1.245V9.68h-1.6v5.393h1.6zm-.288-6.37L1.376 1.14l-1.344.869 4.891 7.563 1.344-.87zM1.544.83h12.913v-1.6H1.544v1.6zm13.081.309L9.733 8.705l1.344.869 4.892-7.565-1.344-.87zM14.457.83a.2.2 0 01.168.309l1.344.869C16.743.81 15.884-.77 14.457-.77v1.6zM1.376 1.14A.2.2 0 011.544.83v-1.6C.117-.769-.742.811.032 2.01l1.344-.87zm5.18 8.54a1.8 1.8 0 00-.29-.977l-1.343.869a.2.2 0 01.032.108h1.6zm.298 5.567a.2.2 0 01-.299-.174h-1.6c0 1.381 1.491 2.248 2.691 1.564l-.792-1.39zm2.59-1.593a.2.2 0 01-.1.174l.792 1.39a1.8 1.8 0 00.909-1.564h-1.6zm1.6-3.972a.2.2 0 01.033-.108l-1.344-.869a1.8 1.8 0 00-.288.977h1.6z","fill":"#ABAFB5","mask":"url(#a)"}})])
          )
        }
      }
    